/**
 * @generated SignedSource<<f5029efbee20c27bbb1951878eeec5f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CategoryEditForm_category$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "CategoryEditForm_category";
};
export type CategoryEditForm_category$key = {
  readonly " $data"?: CategoryEditForm_category$data;
  readonly " $fragmentSpreads": FragmentRefs<"CategoryEditForm_category">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryEditForm_category",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Category",
  "abstractKey": null
};

(node as any).hash = "3eef84543ce30650adb1f90f5f130cf8";

export default node;
